import { useSyncExternalStore } from 'react';
import { subscribeNotices, unreadNoticeCount } from './inbox';

/** Quantos avisos ainda não foram lidos (reage à caixa de entrada). */
export function useUnreadNotices(): number {
  return useSyncExternalStore(subscribeNotices, unreadNoticeCount, () => 0);
}
